import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem('token') || ''}` });

function fmt(dt){
    try { return new Intl.DateTimeFormat('pl-PL',{ dateStyle:'medium', timeStyle:'short' }).format(new Date(dt)); }
    catch { return dt || '—'; }
}

export default function StudentGroupDetailsPage(){
    const { id } = useParams(); // group_id
    const nav = useNavigate();

    const [group, setGroup] = useState(null);
    const [terms, setTerms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState('');

    useEffect(()=>{
        let cancelled = false;
        (async ()=>{
            setLoading(true); setErr('');
            try{
                const g = await fetch(`/api/student/grupa/${id}`, { credentials:'include', headers:{ ...authHeader() }});
                if (!g.ok) throw new Error((await g.json().catch(()=>({})))?.blad || `Błąd (${g.status})`);
                const groupJson = await g.json();

                const t = await fetch(`/api/student/grupa/${id}/terminy`, { credentials:'include', headers:{ ...authHeader() }});
                if (!t.ok) throw new Error((await t.json().catch(()=>({})))?.blad || `Błąd (${t.status})`);
                const termsJson = await t.json();

                if (!cancelled){ setGroup(groupJson); setTerms(Array.isArray(termsJson) ? termsJson : []); }
            }catch(e){ if (!cancelled) setErr(e.message || 'Błąd pobierania'); }
            finally { if (!cancelled) setLoading(false); }
        })();
        return ()=>{ cancelled = true; };
    }, [id]);

    // licznik do startu (live)
    const [now, setNow] = useState(Date.now());
    useEffect(()=>{ const t=setInterval(()=>setNow(Date.now()), 1000); return ()=>clearInterval(t); }, []);
    const left = (iso) => {
        if (!iso) return '—';
        const diff = new Date(iso).getTime() - now;
        const s = Math.max(0, Math.ceil(diff/1000));
        const hh = Math.floor(s/3600), mm = Math.floor((s%3600)/60), ss = s%60;
        return `${hh>0?hh+':':''}${String(mm).padStart(2,'0')}:${String(ss).padStart(2,'0')}`;
    };

    // Fallback gdy backend nie zwróci show_results (np. stare wersje)
    const withUiFlags = useMemo(()=>{
        const FINISHED = new Set(['submitted','auto_graded','awaiting_manual','completed','canceled']);
        return (terms || []).map(t => {
            const show_results = typeof t.show_results === 'boolean'
                ? t.show_results
                : (t.attempt_id ? FINISHED.has(String(t.attempt_status || '').toLowerCase()) : false);
            return { ...t, show_results };
        });
    }, [terms]);

    return (
        <div style={{ maxWidth: 1000, padding:'0 16px', marginTop:80 }}>
            <div style={{ display:'flex', gap:8, marginBottom:12 }}>
                <button onClick={()=>nav('/student/grupy')} style={{ border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 12px', background:'#fff' }}>
                    ← Wszystkie grupy
                </button>
            </div>

            <h1>Szczegóły grupy</h1>

            {loading ? (
                <div>Ładowanie…</div>
            ) : err ? (
                <div style={{ color:'crimson' }}>{err}</div>
            ) : !group ? (
                <div>Brak danych grupy.</div>
            ) : (
                <>
                    <div style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:12, background:'#fff', marginBottom:16 }}>
                        <div style={{ fontWeight:700, fontSize:18 }}>{group.group_name}</div>
                        <div style={{ color:'#6b7280', fontSize:14, marginTop:4 }}>
                            {group.field_of_study || '—'} • semestr {group.study_semester ?? '—'} • {group.study_mode || '—'}
                        </div>
                    </div>

                    <h3>Terminy egzaminów tej grupy</h3>
                    {withUiFlags.length === 0 ? (
                        <div style={{ border:'1px dashed #d1d5db', borderRadius:12, padding:20, color:'#6b7280' }}>
                            Brak zaplanowanych terminów.
                        </div>
                    ) : (
                        <div style={{ display:'grid', gap:12 }}>
                            {withUiFlags.map(t => {
                                const go = () => {
                                    if (t.show_results && t.attempt_id) {
                                        nav(`/student/egzamin/${t.attempt_id}/wyniki`);
                                    } else {
                                        nav(`/student/egzamin/termin/${t.term_id}/start`);
                                    }
                                };
                                const btnLabel = (t.show_results && t.attempt_id) ? 'Wyniki' : 'Przejdź';

                                return (
                                    <div key={t.term_id}
                                         style={{ border:'1px solid #e5e7eb', borderRadius:12, padding:14, background:'#fff',
                                             display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:12 }}>
                                        <div>
                                            <div style={{ fontWeight:700 }}>{t.title || 'Egzamin'}</div>
                                            <div style={{ color:'#6b7280', fontSize:14 }}>
                                                Start: {fmt(t.exam_datetime)} • {t.exam_duration} min • Proctoring: {t.proctoring ? 'tak' : 'nie'}
                                            </div>
                                        </div>
                                        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                                            <span style={{ fontSize:12, color:'#6b7280' }}>Do startu: {left(t.exam_datetime)}</span>
                                            <button
                                                onClick={go}
                                                style={{ border:'1px solid #e5e7eb', borderRadius:8, padding:'8px 12px', background:'#f9fafb' }}>
                                                {btnLabel}
                                            </button>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
